import React from 'react';

/**
 * LoadingSpinner - Spinner de Carga
 * 
 * Indicador de carga animado con tamaños y texto opcional
 */
const LoadingSpinner = ({ size = 'md', text = '', className = '' }) => {
    const sizes = {
        sm: 'w-4 h-4 border-2',
        md: 'w-8 h-8 border-3',
        lg: 'w-12 h-12 border-4',
        xl: 'w-16 h-16 border-4',
    };

    const spinnerSize = sizes[size] || sizes.md;

    return (
        <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
            <div
                className={`${spinnerSize} border-primary-200 border-t-primary-500 rounded-full animate-spin`}
                role="status"
                aria-label="Cargando"
            />
            {text && (
                <p className="text-sm text-gray-600 font-medium animate-pulse">
                    {text}
                </p>
            )}
        </div>
    );
};

// Variante para página completa
LoadingSpinner.FullPage = ({ text = 'Cargando...' }) => {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <LoadingSpinner size="xl" text={text} />
        </div>
    );
};

// Variante inline
LoadingSpinner.Inline = ({ text = '' }) => {
    return (
        <div className="inline-flex items-center gap-2">
            <div
                className="w-4 h-4 border-2 border-primary-200 border-t-primary-500 rounded-full animate-spin"
                role="status"
                aria-label="Cargando"
            />
            {text && <span className="text-sm text-gray-600">{text}</span>}
        </div>
    );
};

export default LoadingSpinner;
